var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { UsuarioService } from '../../services/usuario.service';
import { Causa } from '../../model/causa';
import { Expediente } from '../../model/expediente';
var FichaComponent = (function () {
    function FichaComponent(_usrService, _comService) {
        this._usrService = _usrService;
        this._comService = _comService;
    }
    FichaComponent.prototype.ngOnInit = function () {
    };
    return FichaComponent;
}());
__decorate([
    Input(),
    __metadata("design:type", Causa)
], FichaComponent.prototype, "causa", void 0);
__decorate([
    Input(),
    __metadata("design:type", Expediente)
], FichaComponent.prototype, "exp", void 0);
__decorate([
    Input(),
    __metadata("design:type", Date)
], FichaComponent.prototype, "fecha", void 0);
FichaComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'ficha',
        templateUrl: 'ficha.component.html'
    }),
    __metadata("design:paramtypes", [UsuarioService,
        CommonService])
], FichaComponent);
export { FichaComponent };
//# sourceMappingURL=ficha.component.js.map